import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TopLayerSelect } from 'components/PageBuilder/components/TopLayerSelect';
import { useAsync } from 'react-use';
import { useSelector } from 'react-redux';
import { getBusinessClientObject } from 'store/authentication/selectors';
import { FIELD_TYPES } from 'utility/constants';
import CustomObjectsService from 'services/CustomObjectsService';
import { getCategorizedFieldOptions } from '../utils';

const fetchCategorizedModelFields = async (id) => {
  if (!id) {
    return { options: [], fields: [] };
  }
  const { categorizedFields, fields } =
    await CustomObjectsService.getCategorizedModelFields(id, {
      fieldOptions: {
        params: {
          field_type: FIELD_TYPES.TeamSelector.type,
        },
      },
    });
  return { options: getCategorizedFieldOptions(categorizedFields), fields };
};

export const SendFromTeamMemberField = memo(
  ({
    show,
    sendFromTeamMemberField,
    customObject,
    disabled,
    keyListenersProps,
    showError,
    errorMessage,
    onChange,
    modalLayer,
  }) => {
    const { t } = useTranslation();
    const clientObject = useSelector(getBusinessClientObject);
    const [selectedTab, setSelectedTab] = useState('contacts');

    const { value: options = [], loading } = useAsync(async () => {
      const [
        { options: clientFieldOptions },
        { options: customFieldOptions, fields },
      ] = await Promise.all(
        [clientObject.id, customObject?.id].map(fetchCategorizedModelFields)
      );

      if (customObject) {
        if (
          fields.some((field) => field.id === sendFromTeamMemberField?.value)
        ) {
          setSelectedTab('custom_object');
        }

        return [
          {
            label: t('Contact Fields'),
            options: clientFieldOptions,
            tabKey: 'contacts',
          },
          {
            label: t('{{ entityName }} Fields', customObject),
            options: customFieldOptions,
            tabKey: 'custom_object',
          },
        ];
      }

      return clientFieldOptions;
    }, [clientObject.id, customObject]);

    return show ? (
      <TopLayerSelect
        variant="underline"
        label={t('Send From (Team Selector Field)')}
        validate={{ message: errorMessage, showMessage: showError }}
        modalLayer={modalLayer}
        placeholder={t('Choose Team Selector Field')}
        labelInfo={t(
          'In the event there is no selected team member in the chosen field, this email will come from the last active team member on the record.'
        )}
        disabled={disabled}
        value={sendFromTeamMemberField}
        options={options}
        onChange={onChange}
        {...keyListenersProps}
        showTabs={!!options?.[0]?.tabKey}
        selectedTab={selectedTab}
        isLoading={loading}
      />
    ) : null;
  }
);
